<form [formGroup]="dateHijriForm">
    <label [hidden]="simpleView == true" for="birthDate">
        {{ 'DateHijri' | translate }}
    </label>
    <div class="input-group">
        <input class="form-control form-control-sm" placeholder="{{'DATEFORMAT' | translate}}" ngbDatepicker
            #dp="ngbDatepicker" formControlName="dateHijri">
        <div class="input-group-addon" (click)="dp.toggle()">
        </div>
    </div>
</form>